import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManageChallengeCategoriesComponent } from './manage-challenge-categories.component';
const routes: Routes = [
  {
    path: '',
    component: ManageChallengeCategoriesComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManageChallengeCategoriesRoutingModule { }
